import axios from 'axios';

import lstModules from 'common/json/lstModules.json';

const httpURL = lstModules['main'].url + ':' + lstModules['main'].port;
const httpURLLocal = "http://localhost:8288";
var tokenid = localStorage.getItem("tokenid");
var academicYearId = localStorage.getItem("academicYearId");
var schoolId = localStorage.getItem("schoolId");

// Syllabus dropdown + classes (smsQp � qp_generation_allowed wale syllabus)
export const getSyllabusDropdownSvc = (cbSyllabusList) => {
  const obj = { status: "", message: "" };
  axios({
    url: httpURL + '/sms/qp/v1/list_syllabus',
    method: "POST",
    headers: { 'tokenid': tokenid },
    withCredentials: true,
  }).then((response) => {
    obj.status = response.data.SvcStatus;
    obj.message = response.data.SvcMsg;
    if (response.data.SvcStatus === "Success") {
      obj.lstSyllabus = response.data.lstSyllabus;
    }
    cbSyllabusList(obj);
  }).catch((error) => {
    obj.status = "Exception";
    obj.message = error;
    cbSyllabusList(obj);
  });
}

// Generate question paper � applied pattern ke hisaab se (Harry ka /sms/qp_api/generate_qp)
export const generatePaperV1Svc = (patternId, clsId, subjectId, examId, syllabusId, cbGenerate) => {
  // NOTE: syllabusId ab payload mein nahi bhej rahe � backend prod pe abhi is field ko
  // pehchanta nahi (RQQPGenerator model mein nahi hai), Jackson isliye poora object reject
  // kar deta hai ("Object is invalid"). Backend waise bhi syllabusId ko clsId se khud
  // derive kar leta hai � isliye ye field bhejna zaroori bhi nahi tha.
  const objData = JSON.stringify({
    patternId: Number(patternId),
    clsId: Number(clsId),
    subjectId: Number(subjectId),
    examId: Number(examId),
  });
  const obj = { status: "", message: "" };
  axios({
    url: httpURL + '/sms/qp_api/generate_qp',
    method: "POST",
    params: { objData },
    headers: { 'tokenid': tokenid },
    withCredentials: true,
  }).then((response) => {
    // Generate ka success response "status" field use karta hai (+ paperId/sections),
    // par failure "SvcStatus"/"SvcMsg" � dono handle karo
    obj.status = response.data.status || response.data.SvcStatus;
    obj.message = response.data.SvcMsg || (obj.status === "Success" ? "Question paper generated" : "");
    if (obj.status === "Success") {
      obj.data = response.data;   // paperId, subject, cls, totalQuestions, sections[...]
    }
    cbGenerate(obj);
  }).catch((error) => {
    obj.status = "Exception";
    obj.message = error;
    cbGenerate(obj);
  });
}

// Fetch previously generated question paper(s) for a subject from the question_paper table �
// used so "View PDF" still works after a page refresh, when generatedSetsBySubject (in-memory
// only) has been cleared. New endpoint, local-only until Harry deploys it � same as saveExamQusPattern.
export const getGeneratedQpSvc = (examId, clsId, subjectId, patternId, noOfSets, cbGetQp) => {
  const obj = { status: "", message: "" };
  axios({
    url: httpURL + '/sms/qp_api/get_qp',
    method: "POST",
    params: { examId, clsId, subjectId, patternId, noOfSets },
    headers: { 'tokenid': tokenid },
    withCredentials: true,
  }).then((response) => {
    obj.status = response.data.SvcStatus;
    obj.message = response.data.SvcMsg;
    if (obj.status === "Success") {
      obj.lstSet = response.data.lstSet;
    }
    cbGetQp(obj);
  }).catch((error) => {
    obj.status = "Exception";
    obj.message = error;
    cbGetQp(obj);
  });
}

// Pattern list (v1) � particular syllabus ke hisaab se patterns (Edit slider)
export const getPatternListV1Svc = (syllabusId, cbPatternList) => {
  const obj = { status: "", message: "" };
  axios({
    url: httpURL + '/sms/qp/v1/list_pattern',
    method: "POST",
    params: { syllabusId },
    headers: { 'tokenid': tokenid },
    withCredentials: true,
  }).then((response) => {
    obj.status = response.data.SvcStatus;
    obj.message = response.data.SvcMsg;
    if (response.data.SvcStatus === "Success") {
      obj.lstPattern = response.data.lstPattern;
    }
    cbPatternList(obj);
  }).catch((error) => {
    obj.status = "Exception";
    obj.message = error;
    cbPatternList(obj);
  });
}

// Subject list (v1) � ek syllabus + exam ke subjects, marks/duration/sets/pattern ke saath
export const getSubjectListV1Svc = (examId, syllabusId, cbSubjectList) => {
  const obj = { status: "", message: "" };
  axios({
    url: httpURL + '/sms/qp/v1/list_subject',
    method: "POST",
    params: { examId, syllabusId },
    headers: { 'tokenid': tokenid },
    withCredentials: true,
  }).then((response) => {
    obj.status = response.data.SvcStatus;
    obj.message = response.data.SvcMsg;
    if (response.data.SvcStatus === "Success") {
      obj.lstSubject = response.data.lstSubject;
    }
    cbSubjectList(obj);
  }).catch((error) => {
    obj.status = "Exception";
    obj.message = error;
    cbSubjectList(obj);
  });
}

export function getLstExamSvc(callback) {
  // console.log("getLstExamSvc called");
  axios({
    url: httpURL + '/sms/performance/mst/exam/list',
    method: 'POST',
    params: {},
    headers: { tokenid: tokenid },
    withCredentials: true
  })
    .then(response => {
      // console.log("response in getLstExamSvc", response);
      // console.log('data.SvcStatus=' + response.data.SvcStatus)
      callback(response.data);
    })
    .catch(error => {
      callback(error);
    })
}

export const getExamSyllabusList = (examId, callback) => {
  // console.log("getExamSyllabusList called");
  const formData = new FormData();
  formData.append("examId", examId);
  var obj = { status: "Success", message: "" }
  axios({
    url: httpURL + '/sms/qp/list_syllabus',
    method: "POST",
    data: formData,
    headers: { 'tokenid': tokenid },
    withCredentials: true,
  }).then((response) => {
    // console.log('response in getExamSyllabusList', response);
    obj.status = response.data.SvcStatus;
    obj.message = response.data.SvcMsg;
    if (response.data.SvcStatus === "Success") {
      obj.lstSyllabus = response.data.lstSyllabus;
    }
    callback(obj);
  }).catch((error) => {
    obj.status = "Exception";
    obj.message = error;
    callback(obj);
  });
}

export const getSyllabusPatternList = (callback) => {
  // console.log("getSyllabusPatternList called");
  var obj = { status: "Success", message: "" }
  axios({
    url: httpURL + '/sms/qp/list_pattern',
    method: "POST",
    headers: { 'tokenid': tokenid },
    withCredentials: true,
  }).then((response) => {
    // console.log('response in getSyllabusPatternList', response);
    obj.status = response.data.SvcStatus;
    obj.message = response.data.SvcMsg;
    if (response.data.SvcStatus === "Success") {
      obj.lstPattern = response.data.lstPattern;
    }
    callback(obj);
  }).catch((error) => {
    obj.status = "Exception";
    obj.message = error;
    callback(obj);
  });
}

// Class + section list (v1) � ek syllabus ke classes, sections CSV mein grouped (Harry ka /sms/qp/v1/list_classes)
export const getSyllabusClassesList = (syllabusId, callback) => {
  // console.log("getSyllabusClassesList called");
  var obj = { status: "Success", message: "" }
  axios({
    url: httpURL + '/sms/qp/v1/list_classes',
    method: "POST",
    params: { syllabusId },
    headers: { 'tokenid': tokenid },
    withCredentials: true,
  }).then((response) => {
    // console.log('response in getSyllabusClassesList', response);
    obj.status = response.data.SvcStatus;
    obj.message = response.data.SvcMsg;
    if (response.data.SvcStatus === "Success") {
      obj.lstClasses = response.data.lstCls;
    }
    callback(obj);
  }).catch((error) => {
    obj.status = "Exception";
    obj.message = error;
    callback(obj);
  });
}

export const generateQuestionPaper = (syllabusId, subjectId, examId, callback) => {
  // console.log("generateQuestionPaper called");
  // console.log("examId", examId);
  // console.log("subjectId", subjectId);
  // console.log("syllabusId", syllabusId);
  // console.log("academicYearId", academicYearId);
  // console.log("schoolId", schoolId);
  const formData = new FormData();
  formData.append("examId", examId);
  formData.append("subjectId", subjectId);
  formData.append("syllabusId", syllabusId);
  formData.append("acdYrId", academicYearId);
  formData.append("schoolId", schoolId);
  var obj = { status: "Success", message: "" }
  axios({
    url: httpURLLocal + '/qp/generate',
    method: "POST",
    data: formData,
    headers: { "Content-Type": "application/json" },
    // withCredentials: true,
  }).then((response) => {
    // console.log('response in generateQuestionPaper', response);
    obj.status = response.data.SvcStatus;
    obj.message = response.data.SvcMsg;
    callback(obj);
  }).catch((error) => {
    obj.status = "Exception";
    obj.message = error;
    callback(obj);
  });
}

export const saveExamQusPattern = (RQApplyPattern, callback) => {
  // console.log("saveExamQusPattern called");
  const formData = new FormData();
  formData.append("RQApplyPattern", JSON.stringify(RQApplyPattern));
  var obj = { status: "Success", message: "" }
  axios({
    url: httpURL + '/sms/qp/apply_pattern',
    method: "POST",
    data: formData,
    headers: { 'tokenid': tokenid },
    withCredentials: true,
  }).then((response) => {
    // console.log('response in saveExamQusPattern', response);
    obj.status = response.data.SvcStatus;
    obj.message = response.data.SvcMsg;
    callback(obj);
  }).catch((error) => {
    obj.status = "Exception";
    obj.message = error;
    callback(obj);
  });
}




